<template>
  <div>
    <van-empty v-if="tabs.length == 0" description="暂无公告" />
    <van-collapse v-else border v-model="activeName" accordion>
      <van-collapse-item
        v-for="item in tabs"
        :key="item.id"
        :title="item.name"
        :name="item.id"
        style="text-align: left"
      >
        {{ item.content }}
      </van-collapse-item>
    </van-collapse>
  </div>
</template>

<script>
  import { userSelectList } from "@/api/cardOperation";
  export default {
    data() {
      return {
        tabs: [],
        activeName: "1",
      };
    },
    created() {},
    mounted() {
      this.aa();
    },
    methods: {
      aa() {
        userSelectList().then((res) => {
          if (res.status) {
            this.tabs = res.data;
          }
        });
      },
    },
  };
</script>

<style></style>
